var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ticket, admit, vip"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M11.4375 5.8125V6.1875M11.4375 8.8125V9.1875M11.4375 11.8125V12.1875M3.5625 3.5625H14.4375C15.2659 3.5625 15.9375 4.23407 15.9375 5.0625V6.9375C13.875 7.5 13.875 10.5 15.9375 11.0625V12.9375C15.9375 13.7659 15.2659 14.4375 14.4375 14.4375H3.5625C2.73407 14.4375 2.0625 13.7659 2.0625 12.9375V11.0625C4.125 10.5 4.125 7.5 2.0625 6.9375V5.0625C2.0625 4.23407 2.73407 3.5625 3.5625 3.5625Z",
    stroke: "#FF7926",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.ab6c147d8c4c40c48e8effd332c69a76.svg";
export { ForwardRef as ReactComponent };